import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stream-info-card',
  standalone: false,
  templateUrl: './stream-info-card.component.html',
  styleUrl: './stream-info-card.component.scss'
})
export class StreamInfoCardComponent {
    @Input({ required: true })
    public streamId!: string;

    @Input({ required: false })
    public category: string | null = null;

    @Input({ required: true })
    public title!: string;

    @Input({ required: false })
    public isPremium: boolean = false;

    @Input({ required: true })
    public credits!: number;

    @Input({ required: true })
    public steps!: number;

    @Input({ required: false })
    public description: string | null = null;

    @Output()
    public onClick = new EventEmitter<string>();
}
